import React from 'react';
import { Link } from 'react-router-dom';
import fitLogo from '../../assets/fit-logo.png';

const Footer = () => {
  return (
    <footer className="bg-surface pt-20 pb-10 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1">
            <div className="brand-logo mb-6">
              <img 
                src={fitLogo} 
                alt="FiT Engineering College Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-xs text-gray-500 leading-relaxed pr-4">Empowering the next generation through innovation.</p>
          </div>
          <div>
            <h5 className="font-sans font-bold text-slate text-sm mb-4">Academics</h5>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/academics" className="hover:text-crimson transition">Undergraduate</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-sans font-bold text-slate text-sm mb-4">Quick Links</h5>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/contact" className="hover:text-crimson transition">Contact Us</Link></li>
              <li><Link to="/about" className="hover:text-crimson transition">About Us</Link></li>
              <li><Link to="/terms" className="hover:text-crimson transition">Terms & Conditions</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-sans font-bold text-slate text-sm mb-4">Social</h5>
            <div className="flex gap-4">
              <a href="#" className="w-8 h-8 rounded bg-white border border-gray-200 flex items-center justify-center text-slate hover:bg-crimson hover:text-white transition">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded bg-white border border-gray-200 flex items-center justify-center text-slate hover:bg-crimson hover:text-white transition">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 text-center text-xs text-gray-400">
          <p>&copy; 2025 FiT Engineering College. All Rights Reserved.</p>
          <p className="mt-2">
            <Link to="/terms" className="hover:text-crimson transition">Terms & Conditions</Link> | 
            <Link to="/contact" className="hover:text-crimson transition ml-1">Contact Us</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;